import LayoutArticles from "./LayoutArticles";
import {React} from "react";

const Digital = () => {
    return (<>
            <h1>Numérique</h1>
            <LayoutArticles section={'Digital'} subsection={'Home'}/>
        </>
    );
};
export default Digital;
